import React from 'react';
import { Separator } from './ui/separator';
import { Linkedin, Twitter, Facebook, Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Industries', href: '#industries' },
      { name: 'Companies', href: '#companies' },
      { name: 'Contact', href: '#contact' },
    ],
    companies: [
      { name: 'SAI Fleet', href: '#companies' },
      { name: 'Cars on Terms', href: '#companies' },
      { name: 'SAI IT', href: '#companies' },
      { name: 'VO Capital', href: '#companies' },
      { name: 'SAI Media', href: '#companies' },
      { name: 'SAI Comex', href: '#companies' },
    ],
  };

  return (
    <footer className="bg-background border-t border-border text-foreground">
      <div className="container-custom py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_future-africa/artifacts/wtww1d2p_sai.png.png" 
                alt="SAI GROUP" 
                className="h-10"
              />
            </div>
            <p className="text-foreground/60 leading-relaxed mb-4 max-w-md">
              A pan-African diversified group driving economic growth through strategic investments across mobility, technology, mining, media, healthcare, and real estate.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="bg-muted hover:bg-primary/20 p-2 rounded-lg transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="bg-muted hover:bg-primary/20 p-2 rounded-lg transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="bg-muted hover:bg-primary/20 p-2 rounded-lg transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="mailto:info@saigroup.co.za"
                className="bg-muted hover:bg-primary/20 p-2 rounded-lg transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-foreground/60 hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Companies */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Our Companies</h4>
            <ul className="space-y-2">
              {footerLinks.companies.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-foreground/60 hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-border" />

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-sm text-foreground/50">
            © {currentYear} SAI Group. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a
              href="#"
              className="text-sm text-foreground/50 hover:text-primary transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-sm text-foreground/50 hover:text-primary transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;